export const PLATFORM_APP_TITLE = "TeachPlus";
export const SCHOOL_LOGIN_PENDING_TITLE = "Acesso escolar";
export const SCHOOL_LOGIN_FAVICON = `data:image/svg+xml,${encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><rect x="4" y="4" width="24" height="24" rx="6" fill="#64748b"/></svg>',
)}`;

const platformLoginHosts = (configuredOrigin?: string): string[] => {
  const hosts = [
    "localhost",
    "127.0.0.1",
    "[::1]",
    "teachplus.com.br",
    "www.teachplus.com.br",
    "app.teachplus.com.br",
    "class.teachplus.com.br",
  ];
  if (configuredOrigin) {
    try {
      const configured = new URL(configuredOrigin);
      if (["https:", "http:"].includes(configured.protocol))
        hosts.push(configured.hostname);
    } catch {
      // An invalid optional deployment origin must not broaden login fallback.
    }
  }
  return hosts;
};

export const isPlatformHost = (
  hostname: string,
  configuredOrigin?: string,
): boolean => platformLoginHosts(configuredOrigin).includes(hostname);

/** Runs before Vue: unknown school hosts must not inherit platform tab branding. */
export const createLoginBrandPreflightScript = (
  configuredOrigin?: string,
): string =>
  `!function(){var p=${JSON.stringify(platformLoginHosts(configuredOrigin))}.indexOf(location.hostname)!==-1;document.title=p?${JSON.stringify(PLATFORM_APP_TITLE)}:${JSON.stringify(SCHOOL_LOGIN_PENDING_TITLE)};var i=document.getElementById("app-favicon");if(i)i.setAttribute("href",p?"/favicon.ico":${JSON.stringify(SCHOOL_LOGIN_FAVICON)});}();`;
